<ng-template #modalTemplate>
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{title}}</h4>
  </div>
  <div class="modal-body box-parent">
    <div class="row">
      <div class="col">
        <div class="form-label-group">
          <input type="text" id="un" class="form-control" [(ngModel)]="user.username" placeholder="ชื่อผู้ใช้">
          <label for="un">ชื่อผู้ใช้</label>
        </div>
        <div class="form-label-group">
          <input type="password" id="pw" class="form-control"  [(ngModel)]="user.password" [placeholder]="passwordPlaceHolder" autocomplete="new-password">
          <label for="pw">รหัสผ่าน</label>
        </div>
        <div class="dropdown-label-group">
          <p-dropdown
            class="dv-dropdown"
            selectId="group"
            [options]="groups"
            [(ngModel)]="user.group"
            [autoDisplayFirst]="false"
            placeholder="สิทธิ์การใช้งาน"
            [style]="{'z-index': 3}"
          >
          </p-dropdown>
          <label for="group">สิทธิ์การใช้งาน</label>
        </div>
       <div class="multiSelect-label-group">
          <p-multiSelect
            class="dv-multiSelect"
            [options]="companygroups"
            [(ngModel)]="companyGroupID"
            defaultLabel="เลือกบริษัทที่จะเข้าถึงข้อมูลนี้"
            >
          </p-multiSelect>
          <label for="companygroup">เข้าถึงข้อมูลบริษัท</label>
        </div>
        <div>
          <div *ngIf="user.is_active" style="display: flex; align-items: center;">
            <div style="padding-left:12px; flex-grow: 1;"> สถานะปัจจุบัน: เปิดการใข้งาน </div>
            <button class="col-auto btn btn-dv btn-danger btn-wide" (click)="disableUser()">ระงับการใช้งาน</button>
          </div>
          <div *ngIf="!user.is_active" style="display: flex; align-items: center;">
            <div style="padding-left:12px; flex-grow: 1;"> สถานะปัจจุบัน: ถูกระงับการใช้งาน </div>
            <button class="col-auto btn btn-dv btn-clean btn-wide" (click)="enableUser()">เปิดการใช้งาน</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer m-b-0">
      <div class="col">
        <div class="row m-b-5">
          <div class="col text-center text-red">{{ errorMessage ? errorMessage : '&nbsp;' }}</div>
        </div>
        <div class="row justify-content-center">
          <div class="col">
            <button class="btn btn-dv btn-clean btn-wide m-r-20" (click)="modalRef.hide()">ยกเลิก</button>
          </div>
          <button class="col-auto btn btn-dv btn-wide pull-right" (click)="submit()">{{ createMode ? 'บันทึก' : 'แก้ไข' }}</button>
        </div>
      </div>
  </div>
</ng-template>



// WEBPACK FOOTER //
// /opt/app/src/app/features/profile/profile-list-detail/profile-list-detail.component.html